import { Navigate } from 'react-router-dom';
import { useAffiliatePermissions } from 'src/configs/affiliatePermissions';

// Wraps a route element and redirects to home if the affiliate doesn't have
// the required permission. Root users (isAffiliate=false) always pass through.
const PermissionGuard = ({ permissionKey, children }) => {
  const { isAffiliate, permissions } = useAffiliatePermissions();

  if (isAffiliate && !permissions.includes(permissionKey)) {
    return <Navigate to="/extended-sidebar/menu/home" replace />;
  }

  return children;
};

export default PermissionGuard;
